import { CustomerAPI, KnowledgebaseAPI } from 'api'
import { from } from 'rxjs'
import { pluck } from 'rxjs/operators'
import { checkStatus } from 'utils/rxUtils'

export const api = {
  fetchSettings(orgId) {
    return from(KnowledgebaseAPI
      .get(`/mapping/all/${orgId}`))
      .pipe(
        checkStatus(),
        pluck('data')
      )
  },
  updateSettings(settings) {
    return from(KnowledgebaseAPI
      .put('/mapping', settings))
      .pipe(
        checkStatus(),
        pluck('data')
      )
  },
  fetchBotConfig(orgId) {
    return from(CustomerAPI
      .get(`/organizations/${orgId}/bots/support`))
      .pipe(
        checkStatus(),
        pluck('data')
      )
  },
  fetchSyncedKnowledgeBaseList(orgId) {
    return from(CustomerAPI
    .get(`/organizations/${orgId}/bots/support/datasources`))
    .pipe(
      checkStatus(),
      pluck('data')
    )
  },
  setBotConfig(orgId, botConfig) {
    return from(CustomerAPI
    .patch(`/organizations/${orgId}/bots/support`, botConfig))
    .pipe(
      checkStatus(),
      pluck('data')
    )
  },
  fetchCustomLinks() {
    return from(KnowledgebaseAPI
      .get('/custom_links'))
      .pipe(
        checkStatus(),
        pluck('data')
      )
  },
  editCustomLink(customLink) {
    return from(KnowledgebaseAPI
      .patch(`/custom_links/${customLink.id}`, customLink))
      .pipe(
        checkStatus(),
        pluck('data')
      )
  },
  saveCustomLink(customLink) {
    return from(KnowledgebaseAPI
      .post('/custom_links', customLink))
      .pipe(
        checkStatus(),
        pluck('data')
      )
  },
  deleteCustomLink(id) {
    return from(KnowledgebaseAPI
      .delete(`/custom_links/${id}`))
      .pipe(
        checkStatus(),
        pluck('data')
      )
  }
}
